import { types } from "../types/types";

const initialState = {
  user: null,
  loggedIn: false,
  token: null
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_LOGIN:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        loggedIn: true,
      };
    case types.AUTH_LOGOUT:
      localStorage.clear();
      return {
        user: null,
        loggedIn: false,
        token: null,
      };
    default:
      return state;
  }
};